import { Attachment } from './shared';

export interface OrbitPqrContextPayload {
    callInfo?: { callId: string };
    personType: string;
    typeDocument: string;
    document: string;
    name: string;
    lastName?: string;
    email?: string;
    alternateEmail?: string;
    cellPhone?: string;
    phone?: string;
    gender?: string;
    isLGBTIQ?: boolean;
    country: string;
    location?: string;
    detail: string;
    caseType: string;
    formType?: string;
    admission?: string;
    correspondenceFiling?: string;
    specialCondition?: {
        hasSpecialCondition?: boolean;
        specialCondition?: string;
        observations?: string;
    };
    attachments?: Attachment[];
}

export interface OrbitIntegrationResult {
    sentTo: 'ORBIT';
    status: 'SUCCESS' | 'ERROR';
    pqrPersisted?: boolean;
    externalReferenceId?: string;
    orbitCaseNumber?: string;
    orbitCaseId?: string;
    attachmentsExpected?: number;
    attachmentsUploaded?: number;
    error?: Record<string, unknown>;
    attachmentsError?: Record<string, unknown>;
}

export interface OrbitPqrCreatedSummary {
    id: string;
    consecutiveFormat: string;
    correspondenceFiling?: string;
    reception?: string;
}

export enum OrbitCatalogEnum {
    CaseTypes = 'case-types',
    Categories = 'categories',
    Priorities = 'priorities',
    DocumentTypes = 'document-types',
    PersonTypes = 'person-types',
    Genders = 'genders',
    SpecialConditions = 'special-conditions',
    Countries = 'countries',
    Departments = 'departments',
    Cities = 'cities',
}

export type OrbitCatalogQuery = {
    department_code?: string;
};

export enum OrbitPreferredContactMethodEnum {
    Email = 'EMAIL',
    Sms = 'SMS',
    Phone = 'PHONE',
    Mail = 'PHYSICAL_MAIL',
}

export enum OrbitCaseChannelEnum {
    Web = 'WEB',
    Mobile = 'MOBILE',
    Email = 'EMAIL',
    Phone = 'PHONE',
    InPerson = 'IN_PERSON',
    Chat = 'CHAT',
    Whatsapp = 'WHATSAPP',
    Backoffice = 'BACKOFFICE',
    Video = 'VIDEO',
    Api = 'API',
    Dcf = 'DCF',
}

export interface CreateOrbitCasePayload {
    case_type: string;
    subject: string;
    description: string;
    category_id: string;
    priority_id: string;
    habeas_data_accepted: boolean;
    citizen_document: string;
    citizen_name: string;
    citizen_first_name?: string;
    citizen_last_name?: string;
    citizen_document_type?: string;
    citizen_gender?: number;
    citizen_email?: string;
    citizen_alternative_email?: string;
    citizen_phone?: string;
    citizen_address?: string;
    citizen_city?: string;
    citizen_department?: string;
    citizen_country?: string;
    event_department?: string;
    event_city?: string;
    preferred_contact_method?: OrbitPreferredContactMethodEnum | string;
    external_reference_id?: string;
    channel?: OrbitCaseChannelEnum | string;
    orbit_channel?: string;
    metadata?: Record<string, string | number | boolean>;
    custom_fields?: Record<string, string | number | boolean | null>;
    pqr?: OrbitPqrContextPayload;
}

export interface OrbitCaseCreateResponse {
    orbit?:
        | OrbitCaseCreated
        | { success?: boolean; error?: Record<string, unknown> };
    pqr?: OrbitPqrCreatedSummary;
    integration?: OrbitIntegrationResult;
}

export interface OrbitCaseCreated {
    success?: boolean;
    data?: {
        id: string;
        case_number: string;
        status: string;
        case_type?: string;
        due_date?: string;
        created_at?: string;
    };
}
